/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_6_QInputs */

const en_vc_onl_faq_6_q = /** @type {(inputs: Vc_Onl_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does VectorCraft online open in English when my browser is set to Chinese?`)
};

const zh_vc_onl_faq_6_q = /** @type {(inputs: Vc_Onl_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我的浏览器是中文，在线版却显示英文？`)
};

/**
* | output |
* | --- |
* | "Why does VectorCraft online open in English when my browser is set to Chinese?" |
*
* @param {Vc_Onl_Faq_6_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_6_q = /** @type {((inputs?: Vc_Onl_Faq_6_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_6_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_6_q(inputs)
	return zh_vc_onl_faq_6_q(inputs)
});
export { vc_onl_faq_6_q as "vc.onl.faq.6.q" }